<template>
  <section class="row mt-3 section-contact">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <h1 class="section-title">Liên hệ</h1>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 text-center">
          <address>
            <p>
              <strong>Travellet Vietnam Corporation</strong>
            </p>
            <p>
              <strong>Địa chỉ:</strong> 22 Hồng Hà, Phường 2, Quận Tân Bình, Thành phố Hồ Chí Minh
            </p>
            <p>
              <strong>Email:</strong> biz@travellet.vn
            </p>
          </address>
        </div>
        <div class="col-12">
          <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.976394849806!2d106.66517911462289!3d10.813118192296631!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x317529187de60ee3%3A0x80171d009b20725f!2zMjIgSOG7k25nIEjDoCwgUGjGsOG7nW5nIDIsIFTDom4gQsOsbmgsIFRow6BuaCBwaOG7kSBI4buTIENow60gTWluaCwgVmnhu4d0IE5hbQ!5e0!3m2!1svi!2s!4v1622707361969!5m2!1svi!2s"
              width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactPageComponent"
}
</script>

<style scoped>

</style>
